// extracted by mini-css-extract-plugin
export var emptyState = "_5a-d";
export var statCard = "_5a-c";
export var table = "_5a-0";
export var tableCell = "_5a-4";
export var tableCellClickable = "_5a-5 _5a-4";
export var tableCellDefault = "_5a-6 _5a-4";
export var tableCellEmpty = "_5a-8";
export var tableCellWithValue = "_5a-7";
export var tableContainer = "_5a-e";
export var tableHeaderWeight = "_5a-1";
export var tableHeaderZone = "_5a-2";
export var tableRowHeader = "_5a-3";
export var viewModeButton = "_5a-9";
export var viewModeButtonActive = "_5a-a _5a-9";
export var viewModeButtonInactive = "_5a-b _5a-9";